<template>
  <div style="overflow-x: hidden !important;">
    <v-data-table :headers="headers" :items="mediosOrdered" disable-pagination hide-default-footer auto-resize class="table">
      <template #no-data>
        <p>No hay medios asignados.</p>
      </template>

      <template #item="{ item }">
        <tr @dblclick="zoomMedio(item.ID_MEDIO)" :style="rowColor(item)">
          <td style="text-overflow: ellipsis;max-width: 150px;white-space: nowrap;overflow: hidden;">
            {{ item.MEDIO }} <!-- <span v-show="isMedioFueraHorario(item.ID_MEDIO)" class="font-weight-black">*</span> -->
          </td>

          <td>
            <div class="date-cell">
              <span>{{ item.FECHA_ALARMADO | formatDate }}
                <v-tooltip v-if="item.FECHA_ALARMADO" bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small class="origin-icon" color="#333">{{ getOriginIcon(item, 'FECHA_ALARMADO') }}</v-icon>
                  </template>
                  <span>{{ getOriginLabel(item, 'FECHA_ALARMADO') }}</span>
                </v-tooltip>
              </span>
            </div>
          </td>

          <td>
            <div class="date-cell">
              <span>
                <v-tooltip bottom>
                  <template #activator="{ on: onGeo, attrs: attrsGeo }">
                    <span v-bind="attrsGeo" v-on="onGeo" :class="{ 'underline': item.FECHA_LLEGADA_GEOFENCING }">{{ item.FECHA_EN_CAMINO | formatDate }}</span>
                  </template>
                  <span v-if="item.FECHA_LLEGADA_GEOFENCING">Geofencing: {{ item.FECHA_LLEGADA_GEOFENCING | formatDate }}</span>
                  <span v-else>Geofencing: no hay</span>
                </v-tooltip>
                <v-tooltip v-if="item.FECHA_EN_CAMINO" bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small class="origin-icon" color="#333">{{ getOriginIcon(item, 'FECHA_EN_CAMINO') }}</v-icon>
                  </template>
                  <span>{{ getOriginLabel(item, 'FECHA_EN_CAMINO') }}</span>
                </v-tooltip>
              </span>
            </div>
          </td>

          <td>
            <div class="date-cell">
              <span>{{ item.FECHA_EN_LUGAR | formatDate }}
                <v-tooltip v-if="item.FECHA_EN_LUGAR" bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small class="origin-icon" color="#333">{{ getOriginIcon(item, 'FECHA_EN_LUGAR') }}</v-icon>
                  </template>
                  <span>{{ getOriginLabel(item, 'FECHA_EN_LUGAR') }}</span>
                </v-tooltip>
              </span>
            </div>
          </td>

          <td>
            <div class="date-cell">
              <span>{{ item.FECHA_FINALIZADO | formatDate }}
                <v-tooltip v-if="item.FECHA_FINALIZADO" bottom>
                  <template #activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" small class="origin-icon" color="#333">{{ getOriginIcon(item, 'FECHA_FINALIZADO') }}</v-icon>
                  </template>
                  <span>{{ getOriginLabel(item, 'FECHA_FINALIZADO') }}</span>
                </v-tooltip>
              </span>
            </div>
          </td>

          <td>
            <v-layout>
              <!-- Tiempo -->
              <!-- <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn fab icon small v-bind="attrs" v-on="on" v-show="!item.FECHA_FIN_DESCANSO" :disabled="isClockButtonDisabled(item)" @click="setFechas(item)">
                    <v-icon color="#333"> {{ !item.FECHA_FINALIZADO ? 'mdi-clock-outline' : 'mdi-sleep' }}</v-icon>
                  </v-btn>
                </template>
                <span v-if="!item.FECHA_EN_CAMINO">Asignar llegada</span>
                <span v-if="item.FECHA_EN_CAMINO && !item.FECHA_EN_LUGAR">Asignar salida</span>
                <span v-if="item.FECHA_EN_LUGAR && !item.FECHA_FINALIZADO">Asignar llegada base</span>
                <span v-if="item.FECHA_FINALIZADO && !item.FECHA_FIN_DESCANSO">Asignar descanso</span>
              </v-tooltip> -->

              <!-- Editar -->
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-btn fab icon small v-bind="attrs" v-on="on" @click="editMedio(item)" :disabled="disabledByRol">
                    <v-icon color="#333">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar medio</span>
              </v-tooltip>
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showDialogDescanso" persistent max-width="400">
      <v-card>
        <v-toolbar color="primaryLight" dark dense>
          <v-toolbar-title>Establecer descanso del medio</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pt-8">
          <v-form v-model="isValid">
            <v-container>
              <v-row align="center" justify="center" no-gutters>
                <v-col>
                  <v-slider v-model="horasDescanso" :min="2" :max="24" thumb-label="always" ticks="always" label="Horas descanso" />
                </v-col>
              </v-row>
              <v-row align="center" justify="center" no-gutters>
                <v-col>
                  <v-text-field v-model="fechaFinDescanso" label="Fecha fin de descanso" prepend-icon="esri-icon-calendar" outlined readonly hide-details />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="red" @click="showDialogDescanso = false">Cancelar</v-btn>
          <v-btn text color="green" @click="setFechaFinDescanso">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import constants from '../../../helpers/constants'
import * as ArcGIS from '../../../helpers/ArcGIS'

export default {
  props: {
    medios: Array
  },

  data: () => ({
    headers: [
      { text: 'Medio', value: 'MEDIO', align: 'left', sortable: true }, // width: '35%'
      { text: 'Alarmado', value: 'FECHA_ALARMADO', align: 'center', sortable: true },
      { text: 'En camino', value: 'FECHA_EN_CAMINO', align: 'center', sortable: true },
      { text: 'En lugar', value: 'FECHA_EN_LUGAR', align: 'center', sortable: true },
      { text: 'Finalizado', value: 'FECHA_FINALIZADO', align: 'center', sortable: true },
      { text: '', value: 'ACCIONES', align: 'center', sortable: false }
    ],

    estadoMedios: [],
    showDialogDescanso: false,
    medioSelected: {},
    isValid: false,
    horasDescanso: 10
  }),

  computed: {
    allMedios () {
      return this.$store.getters['medio/medios']
    },

    fechaFinDescanso () {
      let finDescanso = null
      if (this.medioSelected) {
        let llegadaBase = this.$date.parseDate(this.medioSelected.FECHA_FINALIZADO)
        finDescanso = llegadaBase.add(this.horasDescanso, 'hours').format('DD/MM/YYYY HH:mm')
      }
      return finDescanso
    },

    mediosOrdered () {
      let medios = []

      if (this.medios) {
        medios = this.orderMedios()
      }

      return medios
    },

    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  methods: {
    rowColor (item) { // TODO: esto hay que rehacerlo
      let backgroundColor = this.estadoMedios[1].COLOR // Azul
      let borderColor = this.estadoMedios[1].COLOR

      if (item.FECHA_FINALIZADO) {
        backgroundColor = '#CCC8C5'
        borderColor = '#CCC8C5'
      } else if (item.FECHA_EN_LUGAR) {
        backgroundColor = this.estadoMedios[3].COLOR // Amarillo
        borderColor = this.estadoMedios[3].COLOR
      } else if (item.FECHA_EN_CAMINO) {
        backgroundColor = this.estadoMedios[2].COLOR // Rojo
        borderColor = this.estadoMedios[2].COLOR
      }

      // if (!item.FECHA_EN_CAMINO) {
      //   backgroundColor = this.estadoMedios[1].COLOR // Azul
      //   borderColor = this.estadoMedios[1].COLOR
      // } else if (!item.FECHA_EN_LUGAR) {
      //   backgroundColor = this.estadoMedios[2].COLOR // Rojo
      //   borderColor = this.estadoMedios[2].COLOR
      // } else if (!item.FECHA_FINALIZADO) {
      //   backgroundColor = this.estadoMedios[3].COLOR // Amarillo
      //   borderColor = this.estadoMedios[3].COLOR
      // }

      return {
        'background-color': backgroundColor,
        'border-color': borderColor
      }
    },

    isMedioFueraHorario (idMedio) {
      let isMedioFueraHorario = false

      let medio = this.allMedios.find(x => x.ID_MEDIO === idMedio)
      if (medio) {
        let horaSalidaMedio = this.$date.parseDate(medio.HORA_SALIDA, 'HH:mm').format('HH:mm')
        let horaActual = this.$date.formatDate(this.$date.now(), 'HH:mm')
        isMedioFueraHorario = horaActual > horaSalidaMedio
      }
      return isMedioFueraHorario
    },

    orderMedios () {
      let order = JSON.parse(JSON.stringify(this.medios))

      let mediosOrder = order.sort((a, b) => {
        let aEstado = a.ESTADO
        let bEstado = b.ESTADO
        let aMedio = a.MEDIO.toUpperCase()
        let bMedio = b.MEDIO.toUpperCase()

        if (aEstado === bEstado) {
          return (aMedio < bMedio) ? -1 : (aMedio > bMedio) ? 1 : 0
        } else {
          return (aEstado < bEstado) ? -1 : 1
        }
      })

      return mediosOrder
    },

    editMedio (medio) {
      this.$emit('editMedioIncendio', medio)
    },

    isClockButtonDisabled (medio) {
      let now = this.$date.now()
      let fechaAviso = this.$date.parseDate(medio.FECHA_ALARMADO)
      let fechaLlegada = this.$date.parseDate(medio.FECHA_EN_CAMINO)
      let fechaSalida = this.$date.parseDate(medio.FECHA_EN_LUGAR)
      return fechaAviso > now || fechaLlegada > now || fechaSalida > now
    },

    // Click btn reloj
    setFechas (medio) {
      let now = this.$date.now()

      if (!medio.FECHA_EN_CAMINO) {
        medio.FECHA_EN_CAMINO = now
      } else if (!medio.FECHA_EN_LUGAR) {
        medio.FECHA_EN_LUGAR = now
      } else if (!medio.FECHA_FINALIZADO) {
        medio.FECHA_FINALIZADO = now
      } else {
        this.showDialogDescanso = true
        this.medioSelected = medio
      }

      if (!this.showDialogDescanso) {
        this.$emit('setFecha', medio)
      }
    },

    setFechaFinDescanso () {
      this.showDialogDescanso = false
      this.medioSelected.FECHA_FIN_DESCANSO = this.$date.parseDate(this.fechaFinDescanso)
      this.$emit('setFecha', this.medioSelected)
    },

    getDateOrigin (item, field) {
      if (!item[field]) return null
      if (item.FECHAS_ORIGEN && item.FECHAS_ORIGEN[field] === 'WEB') return 'WEB'
      return 'API'
    },

    getOriginIcon (item, field) {
      const origin = this.getDateOrigin(item, field)
      return origin === 'WEB' ? 'mdi-web' : 'mdi-api'
    },

    getOriginLabel (item, field) {
      const origin = this.getDateOrigin(item, field)
      return origin === 'WEB' ? 'Origen: Web' : 'Origen: API'
    },

    zoomMedio (idMedio) {
      let medio = this.allMedios.find(x => x.ID_MEDIO === idMedio)
      if (medio && medio.ULT_POSICION) {
        let center = {
          target: [medio.ULT_POSICION.LONGITUD, medio.ULT_POSICION.LATITUD],
          zoom: 17
        }

        ArcGIS.setCenterMap(center)
      }
    }
  },

  created () {
    this.estadoMedios = constants.estadosMedio
  }
}
</script>

<style scoped>
.table {
  border-radius: 0.25rem;
  overflow: hidden;
}

.date-cell {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
}

.origin-icon {
  flex-shrink: 0;
}
</style>
